import DropdownMenuItem from "ds/components/DropdownMenu/Item";
import { WorkerPool } from "types/generated";
import useCanCycleWorkerPool from "shared/WorkerPool/access/useCanCycleWorkerPool";

type WorkerPoolCycleActionProps = {
  onAction: () => void;
  workerPool: WorkerPool;
};

const hasBusyWorkersTooltip = (
  <>
    Please drain all workers first to make sure that no work is being performed by this worker pool.
    <br />
    <br />
  </>
);

const cycleInfoTooltip = (
  <>
    Cycling worker pool sends a self-destruct signal to all the workers. The process can take up to
    20 seconds to complete.
  </>
);

const WorkerPoolCycleAction = ({ onAction, workerPool }: WorkerPoolCycleActionProps) => {
  const canCycleWorkerPool = useCanCycleWorkerPool();
  const accessResult = canCycleWorkerPool(workerPool);
  const hasBusyWorkers = workerPool.busyWorkers > 0;

  const getTooltip = () => {
    if (!accessResult.result) {
      return accessResult.message;
    }
    if (hasBusyWorkers) {
      return (
        <>
          {hasBusyWorkersTooltip}
          {cycleInfoTooltip}
        </>
      );
    }
    return cycleInfoTooltip;
  };

  const isDisabled = !accessResult.result || hasBusyWorkers;
  const tooltip = getTooltip();

  return (
    <DropdownMenuItem
      tooltip={tooltip}
      isTooltipActive={!!tooltip}
      tooltipWidthMode="maxWidthSm"
      tooltipPlacement="left"
      onAction={onAction}
      isDisabled={isDisabled}
    >
      Cycle
    </DropdownMenuItem>
  );
};

export default WorkerPoolCycleAction;
